import React, { useMemo } from 'react';
import cn from 'classnames';
import { markPlaceholders } from '../../../constants/marks';
import PieCardChart from '../../charts/PieCardChart/PieCardChart';
import styles from '../chartsPlaceholder.module.scss';

const PieCardPlaceholder = ({ title, marksChart, className, style }) => {
  const data = useMemo(() => {
    if (marksChart) {
      return Object.values(markPlaceholders)
        .slice(0, 5)
        .map((markObj) => ({
          ...markObj,
          value: Math.floor(Math.random() * 10) + 1,
          percent: 0,
        }))
        .sort((left, right) => right.value - left.value);
    } else {
      return new Array(6)
        .fill(0)
        .map((_el, index) => ({
          name: `Район ${index + 1}`,
          value: Math.floor(Math.random() * 10) + 1,
          percent: 0,
        }))
        .sort((left, right) => right.value - left.value);
    }
  }, [marksChart]);

  return (
    <div className={cn(className, styles.container)} style={style}>
      <PieCardChart
        colors={['#DED9D9']}
        data={data}
        title={title}
        className={styles.placeholderContainer}
      />
      <div className={styles.placeholder}>Данных нет</div>
    </div>
  );
};

export default PieCardPlaceholder;
